export class Common {
  public static EMAIL_PATTERN = '^[_A-Za-z0-9-\+]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9]+)*(\.[A-Za-z]{2,})$';
  public static TAX_CODE_MAXLENGTH = 20;
  public static REGEX_TIME = /([0-1]?[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]/g;
  public static REGEX_DATE = /(\d{1,4}([.\-/])\d{1,2}([.\-/])\d{1,4})/g;
  public static ACCOUNT_NUMBER_MAXLENGTH = 50;
  public static ACCOUNT_NAME_MAXLENGTH = 200;
  public static BRANCH_NAME_MAXLENGTH = 200;
  public static EMAIL_MAXLENGTH = 100;
  public static BANK_MAXLENGTH = 200;
  public static CERTIFICATE_NO_PATTERN = '^[a-zA-Z0-9\-\/áàảãạÁÀẢÃẠấầẩẫậẤẦẨẪẬắằẳẵặẮẰẲẴẶéèẻẽẹÉÈẺẼẸếềểễệẾỀỂỄỆóòỏõọÓÒỎÕỌớờởỡợỚỜỞỠỢúùủũụÚÙỦŨỤứừửữựỨỪỬỮỰíìỉĩịÍÌỈĨỊýỳỷỹỵÝỲỶỸỴđĐ]*$';
  public static DOCUMENT_CODE_PATTERN = '^[^ 	]*$';
  public static DOCUMENT_CPCODE_PATTERN = '^[a-zA-Z0-9_]*$';
  public static DOCUMENT_CPPASS_PATTERN = '^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[!@#$%^&*\\-\\_\\=\\+\\\\|(){}\\[\\];:\'\`~",<>/?.])[A-Za-z\\d!@#$%^&*\\-\\_\\=\\+\\\\|(){}\\[\\];:\'\`~",<>/?.]{8,}$';
  public static DOCUMENT_CPUSERNAME_PATTERN = '^[a-zA-Z0-9/\"\'\:\;\`\~\!\@\#\$\%\^\&\*\(\)\_\+\=\.\?\\[\\]\}\{\|\\\\>\<\,\-]+$';
  public static DOCUMENT_CPURL_PATTERN = '^(?:http(s)?:\\/\\/)?[\\w.-]+(?:\\.[\\w\\.-]+)+[\\w\\-\\._~:/?#[\\]@!\\$&\'\\(\\)\\*\\+,;=.]+$';
  public static DOCUMENT_STATUS = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11'];
  public static PHONE_PATTERN = '^((\\+91-?)|0)?[0-9]{0,20}$';
  public static PHONE_PATTERN2 = '\\b([0-9]{8,12})\\b';
  public static PHONE_PATTERN3 = '^((\\+91-?)|0)?[0-9]{0,20}$';
  public static PHONE_MAXLENGTH = 20;
  public static PHONE_OTP_MAXLENGTH = 9;
  public static DESCRIPT_PATTERN = '^[0-9]{0,4}$';
  public static DATE_PATTERN = '^(0?[1-9]|[12][0-9]|3[01])/(0?[1-9]|1[012])/(0[1-9]|[1-9][0-9])?[0-9]{4}$';
  public static NUMBER_PATTERN = '^[+-]?[0-9]+([,|\.][0-9]+)?$';
  public static OTP_PATTERN = '^([0-9]{4,6})$';
  public static CA_PASSWORD_PATTERN = '^[a-zA-Z0-9/\"\'\:\;\`\~\!\@\#\$\%\^\&\*\(\)\_\+\=\.\?\\[\\]\}\{\|\\\\>\<\,\-]+$';
  public static MAX_LENGTH_PHONE = 12;
}

export class DateFormat {
  public static FileName = 'YYYYMMDD_HHmmss';
}

export enum CertificateType {

  /**
   * Signature server.
   */
  SIGNATURE_SERVER = 0,
  USB_TOKEN = 1,
  SIM_CA = 2,
  OTP = 3,
  // HSM real
  HSM = 4,
  CLOUD_CA = 10,
  EKYC = 7,
  EKYC_ADVANCED = 8,
  EASY_CA = 11
}

export enum CertificateTypeID {
  CMTND = 30000,
  HO_CHIEU = 30001,
  CCCD = 30002,
  OTHER = 30003
}

export const LIMIT_SIZE = 10485760;
export const ENT_TYPE = {
  1: 'vContract',
  2: 'sContract'
};

export enum EnumDownloadMenuName {
  SEARCH_DOCUMENT = 'HDVBCONGTYLAP',
  SEARCH_DOCUMENT_RECEIVE = 'HDVBNHANTUDOITAC',
  LIST_CONTRACT_BUSINESS = 'HDVBSOHOACONGTYLAP',
  SEARCH_DOCUMENT_MINE = 'HDVBTOILAP',
  SEARCH_DOCUMENT_MINE_RECEIVE = 'HDVBTOINHAN',
  SEARCH_DOCUMENT_SIGN = 'HDVBKYDUYET',
  SEARCH_DOCUMENT_SIGN_APPROVE = 'HDVBPHEDUYET',
  SEARCH_DOCUMENT_SIGN_INITIAL = 'HDVBKYNHAY',
  LIST_CONTRACT = 'HDVBSOHOATOIQUANLY',
  NEGOTIATE_DOCUMENT = 'HDVBTHUONGTHAO',
  VIEW_EMPLOYEE_LIST = 'HDVBDANHSACHNGLAODONG',
  LABOR_CONTRACT = 'HDVBTHONGTINHOPDONG'
}

export enum EnumRoleUser {
  USER_SIGN = '1',
  USER_APPROVER = '2'
}

export enum EnumCustomerType {
  PERSONAL = 10000,
  PRIVATE_COMPANY = 10001,
  AUTHORITY = 10002,
  GOVERNMENT_AGENCIES = 10003,
  STATE_ENTERPRISE = 10004,
  BUSINESS_HOUSEHOLDS = 10005
}

export enum EnumFomatUploadFile {
  UPLOAD_FILE_IMAGE = 'image/jpeg,image/jpg,image/png,image/bmp',
  UPLOAD_FILE = 'image/jpeg,image/jpg,image/png,image/bmp,application/pdf'
}

export enum EnumFileTypeUpload {
  IMAGE_FRONT = '4003',
  IMAGE_BACK = '4004',
  AVATAR = '4005',
  BUSINESS_LICENSE_FRONT = '4006',
  BUSINESS_LICENSE_BACK = '4007'
}

export enum EnumTypeImage {
  PNG = 'image/png',
  JPG = 'image/jpg',
  JPEG = 'image/jpeg',
  BMP = 'image/bmp',
}

export const IMAGE_TYPE = {
  'FILE_CMND_FRONT' : 80,
  'FILE_CMND_BACK': 81,
  'FILE_FACE': 85
}

export enum STEP_VERIFY_EKYC {
  EKYC = 'EKYC',
  VERIFY_PHOTO = 'VERIFY_PHOTO'
}